import { useState, createContext, useContext } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

const ALLOWED_DOMAIN = "srivernj.org";

const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export default function AuthGate({ children }) {
  const [user, setUser] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [error, setError] = useState("");

  const handleSuccess = (res) => {
    try {
      const decoded = jwtDecode(res.credential);

      const email = decoded.email || "";
      const allowed =
        decoded.hd === ALLOWED_DOMAIN || email.endsWith("@" + ALLOWED_DOMAIN);

      if (!allowed) {
        setUser(null);
        setIdToken(null);
        setError(`Access denied. Please use your @${ALLOWED_DOMAIN} account.`);
        return;
      }

      setError("");
      setUser(decoded);
      setIdToken(res.credential);
    } catch {
      setError("Could not verify login. Please try again.");
    }
  };

  if (user) {
    return (
      <AuthContext.Provider value={{ user, idToken }}>
        {children}
      </AuthContext.Provider>
    );
  }

  return (
    <div style={{ maxWidth: 420, margin: "80px auto", textAlign: "center", fontFamily: "sans-serif", padding: 20 }}>
      <h2 style={{ color: "#7a0019" }}>South River Onboarding Portal</h2>
      <p>
        Sign in with your <strong>@{ALLOWED_DOMAIN}</strong> Google account to continue.
      </p>

      <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => setError("Login failed. Please try again.")}
          hd={ALLOWED_DOMAIN}
        />
      </div>

      {error && <p style={{ color: "#c00", marginTop: 20 }}>{error}</p>}
    </div>
  );
}